import classNames from "classnames";
import {forwardRef} from "react";

import {CardProps} from "@/components/card/Card.types.ts";

import styles from "./Card.module.scss";

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({children, className, variant = "default", active, ...props}, ref) => {
    return (
      <div
        ref={ref}
        className={classNames(styles.card, styles[variant], {[styles.active]: active}, className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
